export default "__VITE_ASSET__C8S4jQdj__"